import React from 'react';

import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Link } from 'react-router-dom';
import { EXCEL_DATE_STYLE_ID, LINK_COLOR } from 'src/constants/agGrid';
import { ROUTES } from 'src/constants/routes';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import { getStatusFromStartEndDates, getYYYYMMDDUTCStrFromTimestamp } from 'src/util/grid/cellGetter';
import {
    getPhoneToolLinkCellRenderer,
    getStatusCellRenderer,
    getTerritoryFlagRenderer
} from 'src/util/grid/cellRenderer';
import { dateFilterOptions } from 'src/util/grid/filter';
import { dateComparator, dateFilterComparator } from 'src/util/grid/sort';

export const paperPlanMappingsColDefs: ColDef[] = [
    {
        headerName: 'PAPER plan ID',
        field: 'paperPlanName',
        filter: 'agSetColumnFilter',
        width: 400,
        minWidth: 300,
        cellRenderer: (params: ICellRendererParams) => {
            return (
                <Link
                    style={{ color: LINK_COLOR, textDecoration: 'none' }}
                    to={`${ROUTES.PAPER_PLANS.INDEX}/${params.data.paperPlanId}`}
                    target="_blank"
                >
                    {params.value}
                </Link>
            );
        }
    },
    {
        headerName: 'Base plan ID',
        filter: 'agSetColumnFilter',
        field: 'basePlanName',
        minWidth: 150
    },
    {
        headerName: 'Base plan promo ID',
        field: 'basePlanPromoId',
        filter: 'agTextColumnFilter',
        width: 400,
        minWidth: 200
    },
    {
        headerName: 'Territory',
        filter: 'agSetColumnFilter',
        field: 'territoryCode',
        cellRenderer: (params: ICellRendererParams) => getTerritoryFlagRenderer(params, false),
        minWidth: 120
    },
    {
        headerName: 'Start date',
        field: 'startDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 120
    },
    {
        headerName: 'End date',
        field: 'endDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'lessThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueFormatter: emptyCellFormatter,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 120
    },
    {
        headerName: 'Last updated',
        field: 'lastUpdated',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 180
    },
    {
        headerName: 'Updated by',
        filter: 'agSetColumnFilter',
        field: 'updatedBy',
        cellRenderer: getPhoneToolLinkCellRenderer,
        minWidth: 150
    },
    {
        headerName: 'Status',
        field: 'status',
        valueGetter: getStatusFromStartEndDates,
        cellRenderer: getStatusCellRenderer,
        cellRendererParams: {
            displayText: true
        },
        filter: 'agSetColumnFilter',
        minWidth: 120
    },
    {
        headerName: 'Created by',
        field: 'createdBy',
        filter: 'agSetColumnFilter',
        cellRenderer: getPhoneToolLinkCellRenderer,
        hide: true
    },
    {
        headerName: 'Created',
        field: 'creationDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        hide: true
    },
    {
        headerName: 'Plan/promo description',
        field: 'description',
        filter: 'agTextColumnFilter',
        hide: true
    },
    {
        headerName: 'Base plan mapping name',
        field: 'basePlanMappingName',
        filter: 'agTextColumnFilter',
        hide: true
    },
    {
        headerName: 'Add on mapping name',
        field: 'addOnMappingName',
        filter: 'agTextColumnFilter',
        hide: true
    }
];
